(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcement"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.announcement-slider');
    const slides = slider.querySelectorAll('.announcement-slide');
    const interval = slider.dataset.rotationInterval * 1000;
    const leftArrow = document.querySelector('.arrow.left');
    const rightArrow = document.querySelector('.arrow.right');

    let currentIndex = -1;
    let autoSlideInterval;

    function updateSlides() {
      slides.forEach((slide, index) => {
        const offset = (index - currentIndex + slides.length) % slides.length;
        slide.style.transform = `translateX(${(offset - 1) * 100}%)`;
        if((offset - 1) == 0 ){
          slide.style.opacity = `100`
        }else {
        // wait for translate to finish
         setTimeout(() => {
            slide.style.opacity = `0`;
          }, "500");
        }
 
      });
    }

    function showNextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      updateSlides();
    }

    function showPreviousSlide() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateSlides();
    }

    function startAutoSlide() {
      stopAutoSlide();
      //give first slide time to breath before starting slide
      setTimeout(() => {
        autoSlideInterval = setInterval(showNextSlide, interval);
      }, "2000");
    }

    function stopAutoSlide() {
      clearInterval(autoSlideInterval);
    }

    rightArrow.addEventListener('click', () => {
      stopAutoSlide();
      showNextSlide();
      startAutoSlide();
    });

    leftArrow.addEventListener('click', () => {
      stopAutoSlide();
      showPreviousSlide();
      startAutoSlide();
    });

    updateSlides();
    startAutoSlide();
  });

  } catch(e) { console.error(e); }
})();
})();
